import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api";

const SiteContext = createContext(null);

const FALLBACK = {
  whatsapp: "+917411515444",
  email: "contact@kostrahospitality.com",
  noida_office: "Noida, Uttar Pradesh",
  gurgaon_office: "Gurugram, Haryana",
  tagline: "Product Development | Food Consultancy | Raw Material Supply Solutions",
};

export function SiteProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent({ ...FALLBACK, ...r.data }))
      .catch(() => {});
  }, []);

  const refresh = async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...FALLBACK, ...data });
    } catch {
      /* ignore */
    }
  };

  return (
    <SiteContext.Provider value={{ content, refresh, setContent }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext) || { content: FALLBACK, refresh: () => {} };
}

export function waLinkFromNumber(phone, message = "") {
  const digits = (phone || "").replace(/[^0-9]/g, "");
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}

export function formatPhone(phone) {
  if (!phone) return "";
  const digits = phone.replace(/[^0-9]/g, "");
  if (digits.length === 12 && digits.startsWith("91")) {
    return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  }
  return phone;
}
